import { motion, useReducedMotion } from "framer-motion";

import { useLanguage } from "../i18n/LanguageContext";

const OPTIONS = [
  { code: "en", label: "ENG" },
  { code: "id", label: "IND" },
];

const LanguageToggle = () => {
  const { language, setLanguage, isHome, t } = useLanguage();
  const reduceMotion = useReducedMotion();

  // Only the home page has per-language URLs, so the toggle lives there only.
  if (!isHome) return null;

  return (
    <div
      role="group"
      aria-label={t("navbar.languageLabel")}
      className="landscapes:text-[9px] flex shrink-0 items-center rounded-full border border-[#FFEDD6]/60 bg-black/30 p-[2px] helvetica-500 text-[7px] tracking-normal md:text-[10px] md:tracking-wider 2xl:p-[3px] 2xl:text-sm"
    >
      {OPTIONS.map(({ code, label }) => {
        const active = language === code;
        return (
          <motion.button
            key={code}
            type="button"
            onClick={() => setLanguage(code)}
            aria-pressed={active}
            whileTap={reduceMotion ? undefined : { scale: 0.92 }}
            className={`relative rounded-full px-1 py-[2px] transition-colors md:px-2 duration-300 2xl:px-4 2xl:py-1 ${
              active ? "text-white" : "text-[#FFEDD6] hover:text-white"
            }`}
          >
            {active && (
              // Shared layoutId: the pill slides from the old option to the new one.
              <motion.span
                layoutId="language-toggle-pill"
                aria-hidden="true"
                className="absolute inset-0 rounded-full bg-[#FF6355]"
                transition={
                  reduceMotion
                    ? { duration: 0 }
                    : { type: "spring", stiffness: 500, damping: 35 }
                }
              />
            )}
            <span className="relative z-10">{label}</span>
          </motion.button>
        );
      })}
    </div>
  );
};

export default LanguageToggle;
